import ProjectCard from "../PageLayout/ProjectCard"
import Arthurlytics from "../Projects/Arthurlytics"
import ToggleLightDarkMode from "../Utils/ToggleLightDarkMode"
import styles from "./Summary.module.css"


export default function Summary () {


    return (
        <>
            <ProjectCard>
                <h2 className={styles.title}>HELLo</h2>
                <p>I’m a Software Engineer! I like working on fun problems, exploring tech, and playing Jazz guitar.</p>
                <p>I hope you like my website!</p>

                <div className={styles.links}>

                    {/* <span className={styles.linkTitle}>Links...</span> */}

                    <a href="https://github.com/Portman123" target="_blank" rel="norefferrer noopener" >GitHub</a> 
                    
                        | 
                    
                    <a href="https://www.linkedin.com/in/jan-clare-560353253/" target="_blank" rel="norefferrer noopener">LinkedIn</a> 
                    
                        |
                    
                    <a href="https://www.youtube.com/channel/UC4WgziWOuAtRZ-2rODL4Zsg" target="_blank" rel="norefferrer noopener">Janmakingmusic</a>
                </div>
                
            </ProjectCard>

            <br />
            <br />
            <br />
            <br />
        </>
    )
}